import { render } from "./AccountBalanceSheetV2.vue?vue&type=template&id=24c97cd0"
import script from "./AccountBalanceSheetV2.vue?vue&type=script&lang=js"
export * from "./AccountBalanceSheetV2.vue?vue&type=script&lang=js"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__